import { render, staticRenderFns } from "./CheckoutFooter.vue?vue&type=template&id=16216525&scoped=true"
import script from "./CheckoutFooter.vue?vue&type=script&lang=js"
export * from "./CheckoutFooter.vue?vue&type=script&lang=js"
import style0 from "./CheckoutFooter.vue?vue&type=style&index=0&id=16216525&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16216525",
  null
  
)

export default component.exports